import UserScriptEffect from 'effects/midi/scripting/UserScriptEffect.js';
import StepData from "pattern/StepData.js";
import {setModulesRouting} from 'actions/index.js';
// contains the scripting effect and runs the scripting effect
// to generate the higher order sequencer

export default superclass => class extends superclass {

    // list of modules whose triggers get inputed into
    // the scripting effect, which in turn generates
    // modifications to the H=O Sequencer
    inputModules = [];

    initScripting() {
        this.scriptEffect = new UserScriptEffect(this);
        this.scriptEffect._subSequence = this;
        this.trackData = new StepData();
    }

    // feeds triggers from the sequencer into the H=O sequencer
    // to be processed by the script effect
    input(triggers) {
        this.scriptEffect.onNewStep();
        for (let trigger of triggers) {
            let {stepData} = trigger;
            let track = stepData.track;
            let _trigger = this.scriptEffect.copyTrigger(trigger, true);
            _trigger.stepData.track = track;
            this.scriptEffect.input(_trigger);
        }
    }

    // looks at the processed output of the triggers and modifies
    // the sequencer accordingly
    output(time, step) {
        let output = this.scriptEffect.output(time, step, step);
        if (output.length === 0) {
            // no graphics to process :(
            return;
        }
        let graphics = output.filter(
            x => x.graphics)
            .map(x => x.graphics);

        this.processGraphics(step, graphics);
    }

    toggleInput(module) {
        let {inputModules} = this;
        if (inputModules.includes(module)) {
            this.inputModules = inputModules.filter(
                m => m !== module);
        } else {
            this.inputModules = [... inputModules, module];
        }
        this.updateScriptingRedux();
    }

    toggleOutput(module) {
        let {outputModules} = this;
        if (outputModules.includes(module)) {
            this.outputModules = outputModules.filter(
                m => m !== module);
        } else {
            this.outputModules = [... outputModules, module];
        }
        this.updateScriptingRedux();
    }

    // sets the redux values for inputModules
    updateScriptingRedux() {
        this.sequencerEngine.dispatch(
            setModulesRouting(this.inputModules, this.outputModules));
    }
}
